'use strict';

import Glide from '@glidejs/glide';
import { apiMarketoGetLead, apiUpdateLead } from '../../../api/marketo';
import { addToResourceEventSubscriptions, isPageInResourceEventSubscriptions } from '../../forms/_imports/shared/forms-data-storage.common';

const initSlider = (banner) => {
    const tabs = Array.from(banner.querySelectorAll('.resource-event-slider-banner-tab'));
    const glideElement = banner.querySelector('.glide');
    
    const track = glideElement.querySelector('.glide__track');

    if (!glideElement || !tabs.length || !track) {
        return;
    }

    let slider = null;

    const computePerView = () => {
        const slideFullWidth = parseInt(getComputedStyle(banner).getPropertyValue('--slide-full-width'));
        
        return Math.round(track.getBoundingClientRect().width) / (slideFullWidth + 12);
    };

    const mountSlider = () => {
        const slideGap = parseInt(getComputedStyle(banner).getPropertyValue('--slide-gap')) || 32;

        if (slider) {
            slider.destroy();
        }

        slider = new Glide(banner.querySelector('.glide'), {
            gap: slideGap, 
            type: 'slider',
            animationDuration: 300,
            perView: computePerView(),
            startAt: 0,
            bound: false
        });

        slider.mount();
    };

    setTimeout(() => {
        mountSlider();
    }, 0);

    window.addEventListener('resize', () => {
        mountSlider();
    });

    /*
        Move to the clicked slide
    */
    banner.querySelectorAll('.glide__slide').forEach((slide) => {
        if (!slide.dataset.slideIndex) {
            return;
        }

        slide.addEventListener('click', () => {
            slider.go(`=${slide.dataset.slideIndex}`);
        });
    });
};

const initSlideRegisterCta = (slide) => {
    const cta = slide.querySelector('.resource-event-slide-cta-register');

    if (!cta) {
        return;
    }

    const resourceUrl = cta.dataset.href;

    if (!resourceUrl) {
        return;
    }

    if (isPageInResourceEventSubscriptions(resourceUrl)) {
        cta.classList.add('success');
        return;
    }

    cta.classList.remove('hidden');

    /*
        One-click registration behavior
    */
    cta.addEventListener('click', () => {
        const marketoId = Cookies.get('marketo_id');

        if (!marketoId) {
            window.location = resourceUrl;
            return;
        }

        cta.classList.add('loading');

        apiMarketoGetLead({
            id: marketoId,
            noLeadCreation: true,
            success: () => {
                try {
                    apiUpdateLead({
                        formSerializeString: {
                            MarketoDetailIDUrl: resourceUrl
                        },
                        then: () => {
                            cta.classList.add('success');
                            addToResourceEventSubscriptions(resourceUrl);
                        },
                    });
                } catch {
                    window.location = resourceUrl;
                }
            },
            noResult: () => {
                window.location = resourceUrl;
            },
            error: () => {
                window.location = resourceUrl;
            }
        });
    });
};

const initBanner = (banner) => {
    initSlider(banner);
    
    banner.querySelectorAll('[am-component="resource-event-slide"]').forEach(initSlideRegisterCta);
};

const init = () => {
    document.querySelectorAll('[am-component="resource-event-slider-banner"]:not(.banner-component)').forEach(initBanner);
};

init();
